// extracted by mini-css-extract-plugin
export default {"widget":"Widget_widget__0a0Wo","title":"Widget_title__yJEnK"};